import useSWR from "swr";
import { reservationNumPeopleGraphDateRangeState } from "../../store/reservationNumPeopleGraphDateRangeState";
import { useRecoilValue } from "recoil";

export const useFetchReservationNumPeople = (restaurantId?: string) => {
  const dateRange = useRecoilValue(reservationNumPeopleGraphDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/reservation-num-people/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: reservationNumPeople, isLoading } = useSWR<{[key: string]: number}>(fetcherKey)
  return { reservationNumPeople, isLoading };
};